import { render, staticRenderFns } from "./FlashSaleCustomerGroup.vue?vue&type=template&id=ed219d1a&scoped=true&"
import script from "./FlashSaleCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./FlashSaleCustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./FlashSaleCustomerGroup.vue?vue&type=style&index=0&id=ed219d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed219d1a",
  null
  
)

export default component.exports